interface AudioPreferenceProfile {
  readonly accent_default?: string | null
}

interface PreferredAudioCard {
  readonly femaleAudio?: string | null
  readonly maleAudio?: string | null
}

export function resolvePreferredAudioSource({
  card,
  profile,
}: {
  readonly card: PreferredAudioCard
  readonly profile: AudioPreferenceProfile | null
}) {
  if (profile?.accent_default === 'male_north_accent') {
    return card.maleAudio ?? card.femaleAudio ?? null
  }

  return card.femaleAudio ?? card.maleAudio ?? null
}
